import './plugins/lazyload.js';
/* global jQuery */

(function ($) {
  function headerBurger() {
    const menu = $('#main-menu');
    const toggle = $('#menu-toggle');

    if (!menu.length || !toggle.length) return;
    toggle.on('click', function () {
      menu.toggleClass('is-active');
      toggle.toggleClass('is-active');
      menu.slideToggle(200);
    });

    $(document).on('click', function (e) {
      const target = $(e.target);
      if (menu.hasClass('is-active')) {
        if (
          !target.closest('#main-menu').length &&
          !target.closest('#menu-toggle').length
        ) {
          menu.slideUp(200);
          menu.removeClass('is-active');
        }
      }
    });
  }

  function scrollToTopIfCurrentPage() {
    if (window.location.pathname !== '/') {
      return;
    }

    const menuLinks = document.querySelectorAll('nav a');

    menuLinks.forEach((link) => {
      link.addEventListener('click', function (event) {
        // Get the current page URL and the link's href
        const currentPage = window.location.href;
        const linkHref = link.href;

        // Check if the link points to the current page
        if (currentPage === linkHref || currentPage === linkHref + '/') {
          // Prevent default link action
          event.preventDefault();

          // Scroll to the top of the page smoothly
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      });
    });
  }

  function handleHeaderPosition(header) {
    if ($(window).scrollTop() === 0) {
      header.addClass('position-top');
    } else {
      header.removeClass('position-top');
    }
  }

  $(document).on('ready', function () {
    const header = $('header.header');
    headerBurger();
    scrollToTopIfCurrentPage();
    handleHeaderPosition(header);

    $(window).on('scroll', function () {
      handleHeaderPosition(header);
    });

    // Smooth anchor scrolling
    $('a[href^="#"]').on('click', function (event) {
      const targetId = $(this).attr('href');
      if (targetId.length < 2) return;
      event.preventDefault();

      const targetElement = $(targetId);

      // Check if the target element exists
      if (targetElement.length) {
        const header = $('header.header');
        // Get the target position and compensate for the fixed header
        const targetPosition =
          targetElement.offset().top - header.get(0).clientHeight;

        // Smoothly scroll to the target position
        $('html, body').animate(
          {
            scrollTop: targetPosition,
          },
          500
        ); // Duration of the scroll (800ms)
      }
    });
  });
})(jQuery);
